/**
 * Values for `Suppliers.min_order_total_basis`: which subtotal is compared against
 * `Suppliers.min_order_total`. Line-level discounts and price-group pricing are already in the line
 * totals either way; tax and shipping never count. Unknown values behave as AFTER_DISCOUNTS.
 */
enum MinOrderTotalBasisEnum {
    /**
     * sub_total, before the order-level discount and the promo code discount.
     */
    BEFORE_DISCOUNTS = "before_discounts",
    /**
     * sub_total minus the order-level discount and the promo code discount (the default).
     */
    AFTER_DISCOUNTS = "after_discounts",
}

export default MinOrderTotalBasisEnum;
